import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const login = (username, password) => {
	const url = `${API_URL}/admin/login`;

	return axios
		.post(url, {
			username,
			password,
		})
		.then((response) => {
			if (response.data.data) {
				const { full_name, superuser, authorization, expiration_date, roles, customer } = response.data.data;

				localStorage.setItem("user", full_name);
				localStorage.setItem("superuser", superuser);
				localStorage.setItem("token", JSON.stringify(authorization));
				localStorage.setItem("expiration_date", expiration_date);
				localStorage.setItem("roles", JSON.stringify(roles));

				localStorage.setItem(
					"imp_state",
					JSON.stringify({
						implementation_state_id: customer.implementation_state_id,
						is_implementation_completed: customer.is_implementation_completed,
					}),
				);
			}

			return response.data;
		});
};

const logout = () => {
	const url = `${API_URL}/admin/logout`;

	return axios.post(url).then((response) => {
		localStorage.removeItem("user");
		localStorage.removeItem("superuser");
		localStorage.removeItem("token");
		localStorage.removeItem("expiration_date");
		localStorage.removeItem("roles");
		localStorage.removeItem("imp_state");
		return response;
	});
};

const forgot_password = (email) => {
	const url = `${API_URL}/admin/forgot_password`;

	return axios
		.post(url, {
			email,
		})
		.then((response) => {
			return response.data;
		});
};

const change_password = (password, token) => {
	const url = `${API_URL}/admin/change_password`;

	return axios
		.post(url, {
			password,
			token,
		})
		.then((response) => {
			return response.data;
		});
};

const notification_seen = (notification_id) => {
	const url = `${API_URL}/admin/notification_seen`;

	const form = {
		notification_id,
	};

	return axios
		.post(url, form, {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		})
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			return error;
		});
};

const notification_multiple_seen = (notifications) => {
	const url = `${API_URL}/admin/notification_multiple_seen`;

	const form = {
		notifications,
	};

	return axios
		.post(url, form, {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		})
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			return error;
		});
};

export default {
	login,
	logout,
	forgot_password,
	change_password,
	notification_seen,
	notification_multiple_seen,
};
